import React, { useEffect, useRef, useState } from 'react';
import { ArrowLeft, Gift } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import Navbar from './Navbar';
import Footer from './Footer';

const PAYPAL_CLIENT_ID = 'BAAj5n0ydfxAFN7f7Nm1rGSjLqCudZ8pym9jBMUNfpcYHSkNv9B8MFk1s3sAVuhX2JuF-zyFKJsWvawu7U';
const HOSTED_BUTTON_ID = 'BMPKZHVG49PDN';
const SDK_SRC = `https://www.paypal.com/sdk/js?client-id=${PAYPAL_CLIENT_ID}&components=hosted-buttons&disable-funding=venmo&currency=GBP`;


const PayPalVoucherButton = () => {
  const containerRef = useRef(null);
  const [status, setStatus] = useState('loading');

  useEffect(() => {
    let cancelled = false;
    const render = () => {
      if (cancelled || !containerRef.current || !window.paypal?.HostedButtons) return;
      containerRef.current.innerHTML = '';
      window.paypal
        .HostedButtons({ hostedButtonId: HOSTED_BUTTON_ID })
        .render(containerRef.current)
        .then(() => !cancelled && setStatus('ready'))
        .catch(() => !cancelled && setStatus('error'));
    };

    const existing = document.querySelector(`script[src="${SDK_SRC}"]`);
    if (window.paypal?.HostedButtons) {
      render();
    } else if (existing) {
      existing.addEventListener('load', render);
    } else {
      const script = document.createElement('script');
      script.src = SDK_SRC;
      script.async = true;
      script.onload = render;
      script.onerror = () => setStatus('error');
      document.body.appendChild(script);
    }
    return () => { cancelled = true; };
  }, []);

  return (
    <div data-testid="paypal-voucher-button" className="min-h-[150px]">
      {status === 'loading' && (
        <p className="text-white/50 text-xs tracking-widest text-center py-6">LOADING SECURE CHECKOUT…</p>
      )}
      {status === 'error' && (
        <p data-testid="paypal-error" className="text-red-400 text-sm text-center py-6">
          Checkout could not load. Please refresh or email studio@atlanticcoasttattoo.com.
        </p>
      )}
      <div ref={containerRef} id={`paypal-container-${HOSTED_BUTTON_ID}`} className="bg-white rounded-sm px-5 py-4" />
    </div>
  );
};

const Shop = () => {
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-black">
      <Navbar />

      <section className="pt-32 pb-16 px-4 sm:px-6 lg:px-8">
        <div className="max-w-5xl mx-auto">
          <button
            data-testid="shop-back-btn"
            onClick={() => navigate('/')}
            className="flex items-center gap-2 text-white/70 hover:text-white transition-colors text-sm tracking-wider mb-10"
          >
            <ArrowLeft size={18} />
            BACK TO HOME
          </button>

          <div
            data-testid="voucher-hero-image"
            className="relative w-full pb-[70%] sm:pb-[50%] overflow-hidden border border-white/10 mb-12"
          >
            <img
              src="https://res.cloudinary.com/ddclgpokn/image/upload/v1791544602/Atlantic-coast-tattoo-studio-newquay-Cornwall.jpg"
              alt="Atlantic Coast Tattoo Studio physical gift vouchers - Newquay, Cornwall"
              className="absolute inset-0 w-full h-full object-cover"
            />
          </div>

          <p className="text-white/50 text-xs tracking-[0.3em] mb-3">SHOP</p>
          <h1
            data-testid="shop-title"
            className="font-display text-4xl sm:text-5xl lg:text-6xl font-bold text-white mb-4"
          >
            GIFT VOUCHERS
          </h1>
          <p className="text-white/70 text-base md:text-lg max-w-2xl leading-relaxed">
            Give the gift of ink. Our physical gift vouchers can be used towards any tattoo or laser
            removal treatment at Atlantic Coast Tattoo, Newquay.
          </p>
        </div>
      </section>

      <section className="pb-24 px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl mx-auto">
          <div className="border border-white/15 bg-white/[0.03] p-6 sm:p-8 md:p-10" data-testid="voucher-card">
            <div className="flex items-start justify-between gap-6 mb-8">
              <div>
                <div className="flex items-center gap-3 text-white mb-2">
                  <Gift size={22} />
                  <h2 className="text-base md:text-lg font-bold tracking-widest">GIFT VOUCHER</h2>
                </div>
                <p className="text-white/60 text-sm">Posted to you, individually numbered, valid 12 months. Full terms &amp; conditions below.</p>
              </div>
              <p data-testid="voucher-price" className="text-right whitespace-nowrap">
                <span className="block text-white/50 text-[10px] tracking-widest">FROM</span>
                <span className="text-3xl md:text-4xl font-bold text-white">£20</span>
                <span className="text-base text-white/60 ml-1">GBP</span>
              </p>
            </div>
            <p className="text-white/50 text-xs tracking-wider mb-4">
              Choose your voucher value below, then pay securely with PayPal or card.
            </p>
            <PayPalVoucherButton />
            <p className="text-white/40 text-xs text-center mt-4">Secure payment via PayPal — no PayPal account required. After paying, choose "Return to merchant" to see your confirmation.</p>
          </div>

        </div>
      </section>

      <Footer />
    </div>
  );
};

export default Shop;
